/* eslint-disable eqeqeq */
import { FormRow } from 'framework/ui/layout';
import { PositionDropdown, SOFTWARE_ENGINEER_ID } from 'domain/shared/employee';
import { TechnologyDropdown } from 'domain/shared/career';
import { get } from 'lodash';
import { NumberInput, EnumDropdown, ClearAfterUnmountWrapper, useFormContext, TextInput } from 'framework/form';
import { PROJECT_MEMBERSHIP_ROLES } from '../../../core/constants';
import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';

const TeamPositionsInputs = ({ source, ...props }: { source: string }) => {
  const { data } = useFormContext();
  const { ACCOUNT_MANAGER, ...projectRolesForDropdown } = PROJECT_MEMBERSHIP_ROLES;

  return (
    <FormRow>
      <PositionDropdown source={`${source}.positionId`} label="Position" />
      <EnumDropdown options={projectRolesForDropdown} source={`${source}.requiredRole`} label="Project role" />
      <ClearAfterUnmountWrapper isVisible={get(data, `${source}.positionId`) == SOFTWARE_ENGINEER_ID}>
        <TechnologyDropdown source={`${source}.technologyId`} label="Technology" />
      </ClearAfterUnmountWrapper>
      <FormRow colXl={6}>
        <EnumDropdown options={EMPLOYEE_COMPETENCY_LEVEL} source={`${source}.competencyLevel`} />
        <NumberInput source={`${source}.requiredFte`} label="FTE" />
      </FormRow>
      <TextInput source={`${source}.description`} label="Note" />
    </FormRow>
  );
};

export default TeamPositionsInputs;
